import { makeStyles, styled } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  dialogPaper: {
    borderRadius: theme.shape.borderRadius,
    maxHeight: '80dvh'
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between'
  },
  dialogContent: {
    padding: theme.spacing(2, 0),
    paddingBottom: 0
  },
  optionContainer: {
    alignItems: 'flex-start',
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(1),
    cursor: 'pointer',
    display: 'flex',
    flex: '0 0 calc(50% - 8px)',
    flexDirection: 'column',
    font: 'inherit',
    justifyContent: 'flex-start',
    minWidth: 0,
    overflowWrap: 'break-word',
    padding: theme.spacing(2),
    textAlign: 'left',
    transition: 'border-color 0.2s ease, background-color 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.primary.FP50,
      borderColor: theme.palette.primary.main
    },
    '&:focus': {
      backgroundColor: theme.palette.primary.FP50,
      borderColor: theme.palette.primary.main,
      outline: 'none'
    }
  }
}));

export const LoaderContainer = styled('div')({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  minHeight: '200px'
});
